import OcomProjectList from "./pages/ListPage.vue";
import OcomProjectDetail from "./pages/FormPage.vue";
import OcomProjectIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/ocom_project",
    component: OcomProjectIndex,
    redirect: "/ocom_project/list",
    name: "ocom_project",
    children: [
      {
        path: "list",
        component: OcomProjectList,
        name: "ocom_project.list",
      },
      {
        path: "create",
        component: OcomProjectDetail,
        name: "ocom_project.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: OcomProjectDetail,
        name: "ocom_project.edit",
        props: { create: false },
      },
    ],
  },
];
